function snakeToCamel(key: string): string {
  return key.replace(/_([a-z0-9])/gi, (_, char) => char.toUpperCase());
}

type CamelCase<S extends string> = S extends `${infer Head}_${infer Tail}`
  ? `${Head}${Capitalize<CamelCase<Tail>>}`
  : S;

type CamelCaseKeys<T> =
  T extends Array<infer U>
    ? Array<CamelCaseKeys<U>>
    : T extends Record<string, unknown>
      ? {
          [K in keyof T as K extends string ? CamelCase<K> : K]: CamelCaseKeys<
            T[K]
          >;
        }
      : T;

export function camelCaseKeys<T>(obj: T): CamelCaseKeys<T> {
  if (Array.isArray(obj)) {
    return obj.map(camelCaseKeys) as CamelCaseKeys<T>;
  }

  if (obj !== null && typeof obj === "object" && !(obj instanceof Date)) {
    const result: Record<string, unknown> = {};
    for (const [key, value] of Object.entries(obj)) {
      result[snakeToCamel(key)] = camelCaseKeys(value);
    }
    return result as CamelCaseKeys<T>;
  }

  return obj as CamelCaseKeys<T>;
}
